import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

import MenuItem from "@mui/material/MenuItem";
import PaymentTypeSelect from "../../../Components/PaymentTypeSelect";
import CircularProgress from "@mui/material/CircularProgress";
import Autocomplete from "@mui/material/Autocomplete";
import IconButton from "@mui/material/IconButton";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { ApiLink } from "../../../APILink/ApiLink";
import authHeader from "../../../Auth/authHeader";
import LoginUserDetailed from "../../../Auth/LoginUserDetailed";
import { FiscalYearContext } from "../../../FiscalYear/FiscalYearContext";
import { useVatDeclarant } from "../../../GetData/Context/CompanyDataContext";
import { getUnitID } from "../../../Auth/GetUnitCompany";
import {
  errorAlert,
  getApiErrorMessage,
  handleSuccess,
} from "../../../Components/Alerts";
import AccountsAutocompleteEdit from "../../../Components/AccountsAutocompleteEdit";
import AccountsAutocompleteInsert from "../../../Components/AccountsAutocompleteInsert";
import PriceField from "../../../Components/NumberFieldFormater";
import SuppliersModal from "../../SuppliersCRUD/SuppliersModal";
import ExpencesTypeModal from "../../ExpensesTypeCRUD/ExpencesTypeModal";
import "./PurchaseForm.scss";

const round2 = (value) => {
  const parsed = Number(value || 0);
  if (!Number.isFinite(parsed)) {
    return 0;
  }
  return Math.round((parsed + Number.EPSILON) * 100) / 100;
};

const formatEuroValue = (value) =>
  Number(value || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const TRANSACTION_TYPES = [
  // { id: 1, type: "Vendore" },
  // { id: 2, type: "Eksport" },
  {
    id: 1,
    type: "Vendor",
  },
  {
    id: 2,
    type: "Import",
  },
  {
    id: 3,
    type: "Import i Sherbimeve",
  },
  {
    id: 4,
    type: "Ngarkesa e Kundert",
  },
];

//   const TranscationData = [
//     {
//       id: 1,
//       type: "Vendor",
//     },
//     {
//       id: 2,
//       type: "Import",
//     },
//     {
//       id: 3,
//       type: "Import i Sherbimeve",
//     },
//     {
//       id: 4,
//       type: "Ngarkesa e Kundert",
//     },
//   ];
const createEmptySnapshot = () => ({
  invoiceNr: "",
  date: "",
  payDate: "",
  supplierId: "",
  accountId: "",
  paymentOptions: "",
  transactionType: 1,
  comment: "",
  amount0: 0,
  amount8: 0,
  amount18: 0,
  vat8: 0,
  vat18: 0,
  total0: 0,
  total8: 0,
  total18: 0,
});

export default function PurchaseExpenceForm() {
  const history = useHistory();
  const location = useLocation();
  const { transactionId } = useParams();
  const headers = useMemo(() => authHeader(), []);
  const createdByUser = LoginUserDetailed();
  const { fiscalYear } = useContext(FiscalYearContext);
  const isVatDeclarant = useVatDeclarant();
  const isEditMode = Boolean(transactionId);

  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [invoiceNr, setInvoiceNr] = useState("");
  const [date, setDate] = useState("");
  const [payDate, setPayDate] = useState("");
  const [payDateManuallyEdited, setPayDateManuallyEdited] = useState(false);
  const [supplierId, setSupplierId] = useState("");
  const [supplierOption, setSupplierOption] = useState(null);
  const [accountId, setAccountId] = useState("");
  const [expenseOption, setExpenseOption] = useState(null);
  const [paymentOptions, setPaymentOptions] = useState("");
  const [validationErrors, setValidationErrors] = useState({
    invoiceNr: "",
    date: "",
    payDate: "",
    supplierId: "",
    accountId: "",
    paymentOptions: "",
  });
  const [transactionType, setTransactionType] = useState(1);
  const [comment, setComment] = useState("");
  const [unitId, setUnitId] = useState(null);

  const [amount0, setAmount0] = useState(0);
  const [amount8, setAmount8] = useState(0);
  const [amount18, setAmount18] = useState(0);
  const [vat8, setVat8] = useState(0);
  const [vat18, setVat18] = useState(0);
  const [total0, setTotal0] = useState(0);
  const [total8, setTotal8] = useState(0);
  const [total18, setTotal18] = useState(0);

  const [expenseAccounts, setExpenseAccounts] = useState([]);
  const [supplierAccounts, setSupplierAccounts] = useState([]);
  const [paymentTypes, setPaymentTypes] = useState([]);
  // const [paymentTypes, setPaymentTypes] = useState([]);
  const [invNumberExist, setInvNumberExist] = useState(0);
  const [invoiceOtherSupplierMessage, setInvoiceOtherSupplierMessage] =
    useState("");
  const [initialInvoiceNr, setInitialInvoiceNr] = useState("");
  const [editingTransactionId, setEditingTransactionId] = useState("");
  const [isInitializing, setIsInitializing] = useState(isEditMode);
  const [showSupplierModal, setShowSupplierModal] = useState(false);
  const [showExpenseModal, setShowExpenseModal] = useState(false);
  const [showCloseConfirm, setShowCloseConfirm] = useState(false);
  const [initialFormSnapshot, setInitialFormSnapshot] = useState(
    createEmptySnapshot(),
  );
  const invoiceNrInputRef = useRef(null);

  const paymentMenuProps = {
    PaperProps: {
      sx: {
        maxHeight: 280,
        maxWidth: "min(460px, calc(100vw - 32px))",
        mt: 0.5,
        overflowY: "auto",
        borderRadius: "10px",
        "& .MuiMenuItem-root": {
          fontSize: "13px",
          minHeight: 36,
          whiteSpace: "normal",
          wordBreak: "break-word",
        },
      },
    },
  };

  const sharedDropdownIcon = (props) => (
    <svg
      {...props}
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#4E7B67"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="6 9 12 15 18 9" />
    </svg>
  );

  useEffect(() => {
    setMinDate(`${fiscalYear}-01-01`);
    setMaxDate(`${fiscalYear}-12-31`);
  }, [fiscalYear]);

  useEffect(() => {
    getUnitID(headers).then((id) => setUnitId(id || null));
  }, [headers]);

  const fetchExpenseAccounts = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Accounts/accountByLedger",
        { headers, params: { ledger: 609 } },
      );
      setExpenseAccounts(response.data || []);
    } catch (error) {
      errorAlert(
        getApiErrorMessage(error, "Gabim në marrjen e klasave të shpenzimit."),
      );
    }
  };

  const fetchSupplierAccounts = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Accounts/accountByLedger",
        { headers, params: { ledger: 302 } },
      );
      setSupplierAccounts(response.data || []);
    } catch (error) {
      errorAlert(getApiErrorMessage(error, "Gabim në marrjen e furnitorëve."));
    }
  };

  const fetchPaymentTypes = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Accounts/paymenttype",
        {
          headers,
        },
      );
      setPaymentTypes(response.data || []);
    } catch (error) {
      errorAlert(
        getApiErrorMessage(error, "Gabim në marrjen e mënyrave të pagesës."),
      );
    }
  };

  useEffect(() => {
    fetchExpenseAccounts();
    fetchSupplierAccounts();
    fetchPaymentTypes();
  }, []);

  useEffect(() => {
    if (!isEditMode) {
      setInitialFormSnapshot(createEmptySnapshot());
    }
  }, [isEditMode]);

  useEffect(() => {
    if (isInitializing || isEditMode) {
      return;
    }

    const timerId = window.setTimeout(() => {
      if (invoiceNrInputRef.current) {
        invoiceNrInputRef.current.focus();
      }
    }, 0);

    return () => window.clearTimeout(timerId);
  }, [isInitializing, isEditMode]);

  useEffect(() => {
    if (!payDateManuallyEdited) {
      setPayDate(date);
    }
  }, [date, payDateManuallyEdited]);

  useEffect(() => {
    if (!accountId) {
      setExpenseOption(null);
      return;
    }

    const selectedExpense = expenseAccounts.find(
      (option) => String(option.AccountID) === String(accountId),
    );

    if (selectedExpense) {
      setExpenseOption(selectedExpense);
    }
  }, [expenseAccounts, accountId]);

  useEffect(() => {
    let isCancelled = false;

    const fillFormForEdit = (item) => {
      const safeInvoiceNr = item?.InvoiceNr || "";
      const supplierAccountId = item?.SupplierID || item?.AccountID || "";
      const expenseAccountId = item?.AccountIDSpare || "";
      const amount0Value = Number(item?.Amount0 || 0);
      const amount8Value = Number(item?.Amount8 || 0);
      const amount18Value = Number(item?.Amount18 || 0);
      const vat8Value =
        item?.VAT8 !== undefined && item?.VAT8 !== null
          ? Number(item.VAT8)
          : amount8Value * 0.08;
      const vat18Value =
        item?.VAT18 !== undefined && item?.VAT18 !== null
          ? Number(item.VAT18)
          : amount18Value * 0.18;

      setEditingTransactionId(item?.TransactionID || transactionId || "");
      setInvoiceNr(safeInvoiceNr);
      setInitialInvoiceNr(safeInvoiceNr);
      const invoiceDateIso = (item?.Date || "").substring(0, 10);
      const paymentDateIso = (item?.PayDate || item?.Date || "").substring(
        0,
        10,
      );
      setDate(invoiceDateIso);
      setPayDate(paymentDateIso);
      setPayDateManuallyEdited(
        Boolean(paymentDateIso && paymentDateIso !== invoiceDateIso),
      );
      setSupplierId(supplierAccountId);
      setSupplierOption(
        supplierAccountId
          ? {
              AccountID: supplierAccountId,
              AccountName: item?.AccountName || item?.SupplierName || "",
            }
          : null,
      );
      setAccountId(expenseAccountId);
      setPaymentOptions(String(item?.PaymentOptions ?? ""));
      setTransactionType(Number(item?.TransactionType || 1));
      setComment(item?.Coment || "");

      setAmount0(amount0Value);
      setAmount8(amount8Value);
      setAmount18(amount18Value);
      setVat8(vat8Value);
      setVat18(vat18Value);
      setTotal0(amount0Value);
      setTotal8(amount8Value + vat8Value);
      setTotal18(amount18Value + vat18Value);

      setInitialFormSnapshot({
        invoiceNr: safeInvoiceNr,
        date: invoiceDateIso,
        payDate: paymentDateIso,
        supplierId: String(supplierAccountId || ""),
        accountId: String(expenseAccountId || ""),
        paymentOptions: String(item?.PaymentOptions ?? ""),
        transactionType: Number(item?.TransactionType || 1),
        comment: item?.Coment || "",
        amount0: round2(amount0Value),
        amount8: round2(amount8Value),
        amount18: round2(amount18Value),
        vat8: round2(vat8Value),
        vat18: round2(vat18Value),
        total0: round2(amount0Value),
        total8: round2(amount8Value + vat8Value),
        total18: round2(amount18Value + vat18Value),
      });
    };

    const initEditMode = async () => {
      if (!isEditMode) {
        setIsInitializing(false);
        return;
      }

      const expensePurchase = location?.state?.expensePurchase;
      if (expensePurchase) {
        fillFormForEdit(expensePurchase);
        setIsInitializing(false);
        return;
      }

      try {
        const response = await axios.get(
          ApiLink.API_URL + `ExpensePurchases/${transactionId}`,
          { headers },
        );

        if (!isCancelled) {
          fillFormForEdit(response.data);
        }
      } catch (error) {
        if (!isCancelled) {
          errorAlert(
            getApiErrorMessage(error, "Nuk u gjet shpenzimi për editim."),
          );
          history.push("/expences/expensepurchases");
        }
      } finally {
        if (!isCancelled) {
          setIsInitializing(false);
        }
      }
    };

    initEditMode();

    return () => {
      isCancelled = true;
    };
  }, [isEditMode, location, transactionId, headers, history]);

  useEffect(() => {
    if (!invoiceNr || !supplierId) {
      setInvNumberExist(0);
      setInvoiceOtherSupplierMessage("");
      return;
    }

    let isCancelled = false;

    const validateInvoice = async () => {
      try {
        const response = await axios.get(
          ApiLink.API_URL + "ExpensePurchases/invoice-validation",
          {
            headers,
            params: {
              invNumber: invoiceNr,
              fiscalYear,
              supplierId: Number(supplierId),
              transactionId: isEditMode
                ? Number(editingTransactionId || transactionId || 0)
                : 0,
            },
          },
        );

        if (isCancelled) return;

        const sameSupplierExists = Boolean(response?.data?.sameSupplierExists);
        const existsWithOtherSupplier = Boolean(
          response?.data?.existsWithOtherSupplier,
        );
        const otherSupplierNames = response?.data?.otherSupplierNames || "";

        setInvNumberExist(sameSupplierExists ? 1 : 0);

        if (!sameSupplierExists && existsWithOtherSupplier) {
          setInvoiceOtherSupplierMessage(
            `Ky numër i faturës ekziston për furnitor tjetër: ${otherSupplierNames}`,
          );
        } else {
          setInvoiceOtherSupplierMessage("");
        }
      } catch (error) {
        if (!isCancelled) {
          setInvNumberExist(0);
          setInvoiceOtherSupplierMessage("");
        }
      }
    };

    validateInvoice();

    return () => {
      isCancelled = true;
    };
  }, [
    invoiceNr,
    supplierId,
    fiscalYear,
    headers,
    isEditMode,
    editingTransactionId,
    transactionId,
  ]);

  const recalcByNet = (net, vatRate) => {
    const base = Number(net || 0);
    const vat = base * (vatRate / 100);
    const total = base + vat;

    if (vatRate === 18) {
      setAmount18(base);
      setVat18(vat);
      setTotal18(total);
    }
    if (vatRate === 8) {
      setAmount8(base);
      setVat8(vat);
      setTotal8(total);
    }
    if (vatRate === 0) {
      setAmount0(base);
      setTotal0(base);
    }
  };

  const recalcByTotal = (gross, vatRate) => {
    const total = Number(gross || 0);
    const base = vatRate === 0 ? total : (total * 100) / (100 + vatRate);
    const vat = total - base;

    if (vatRate === 18) {
      setAmount18(base);
      setVat18(vat);
      setTotal18(total);
    }
    if (vatRate === 8) {
      setAmount8(base);
      setVat8(vat);
      setTotal8(total);
    }
    if (vatRate === 0) {
      setAmount0(base);
      setTotal0(total);
    }
  };

  const recalcFromVat = (vatValue, vatRate) => {
    if (vatRate === 0) {
      return;
    }

    const vat = Number(vatValue || 0);
    const base = vat / (vatRate / 100);
    const total = base + vat;

    if (vatRate === 18) {
      setAmount18(base);
      setVat18(vat);
      setTotal18(total);
    }
    if (vatRate === 8) {
      setAmount8(base);
      setVat8(vat);
      setTotal8(total);
    }
  };

  const totals = useMemo(() => {
    const totalNoVat = round2(
      Number(amount0) + Number(amount8) + Number(amount18),
    );
    const totalVat = round2(Number(vat8) + Number(vat18));
    const totalWithVat = round2(totalNoVat + totalVat);
    return { totalNoVat, totalVat, totalWithVat };
  }, [amount0, amount8, amount18, vat8, vat18]);

  const currentFormSnapshot = useMemo(
    () => ({
      invoiceNr: invoiceNr || "",
      date: date || "",
      payDate: payDate || "",
      supplierId: String(supplierId || ""),
      accountId: String(accountId || ""),
      paymentOptions: String(paymentOptions || ""),
      transactionType: Number(transactionType || 1),
      comment: comment || "",
      amount0: round2(amount0),
      amount8: round2(amount8),
      amount18: round2(amount18),
      vat8: round2(vat8),
      vat18: round2(vat18),
      total0: round2(total0),
      total8: round2(total8),
      total18: round2(total18),
    }),
    [
      invoiceNr,
      date,
      payDate,
      supplierId,
      accountId,
      paymentOptions,
      transactionType,
      comment,
      amount0,
      amount8,
      amount18,
      vat8,
      vat18,
      total0,
      total8,
      total18,
    ],
  );

  const isFormDirty = useMemo(
    () =>
      JSON.stringify(currentFormSnapshot) !==
      JSON.stringify(initialFormSnapshot),
    [currentFormSnapshot, initialFormSnapshot],
  );

  const isInsertFormEmpty = useMemo(() => {
    if (isEditMode) return false;
    return (
      !invoiceNr &&
      !date &&
      !payDate &&
      !supplierId &&
      !accountId &&
      !paymentOptions &&
      !comment &&
      amount0 === 0 &&
      amount8 === 0 &&
      amount18 === 0
    );
  }, [
    isEditMode,
    invoiceNr,
    date,
    payDate,
    supplierId,
    accountId,
    paymentOptions,
    comment,
    amount0,
    amount8,
    amount18,
  ]);

  const closePage = () => {
    history.push("/expences/expensepurchases");
  };

  const handleCloseClick = () => {
    if (isFormDirty) {
      setShowCloseConfirm(true);
      return;
    }
    closePage();
  };

  const resetForm = () => {
    setInvoiceNr("");
    setDate("");
    setPayDate("");
    setPayDateManuallyEdited(false);
    setSupplierId("");
    setSupplierOption(null);
    setAccountId("");
    setExpenseOption(null);
    setPaymentOptions("");
    setTransactionType(1);
    setComment("");
    setAmount0(0);
    setAmount8(0);
    setAmount18(0);
    setVat8(0);
    setVat18(0);
    setTotal0(0);
    setTotal8(0);
    setTotal18(0);
    setInvNumberExist(0);
    setInvoiceOtherSupplierMessage("");
    setInitialFormSnapshot(createEmptySnapshot());
    setValidationErrors({
      invoiceNr: "",
      date: "",
      payDate: "",
      supplierId: "",
      accountId: "",
      paymentOptions: "",
    });
  };

  const validateBeforeSubmit = () => {
    const nextErrors = {
      invoiceNr: "",
      date: "",
      payDate: "",
      supplierId: "",
      accountId: "",
      paymentOptions: "",
    };

    if (!invoiceNr) {
      nextErrors.invoiceNr = "Numri i faturës është i detyrueshëm.";
    }
    if (!date) {
      nextErrors.date = "Data e faturës është e detyrueshme.";
    }
    if (!payDate) {
      nextErrors.payDate = "Data e pagesës është e detyrueshme.";
    }
    if (!supplierId) {
      nextErrors.supplierId = "Ju lutem zgjidhni furnitorin.";
    }
    if (!accountId) {
      nextErrors.accountId = "Ju lutem zgjidhni klasën e shpenzimit.";
    }
    if (!paymentOptions) {
      nextErrors.paymentOptions = "Ju lutem zgjidhni mënyrën e pagesës.";
    }

    if (Object.values(nextErrors).some(Boolean)) {
      setValidationErrors(nextErrors);
      return false;
    }

    if (invNumberExist > 0) {
      return false;
    }

    setValidationErrors({
      invoiceNr: "",
      date: "",
      payDate: "",
      supplierId: "",
      accountId: "",
      paymentOptions: "",
    });

    return true;
  };

  const focusInvoiceField = () => {
    window.setTimeout(() => {
      if (invoiceNrInputRef.current) {
        invoiceNrInputRef.current.focus();
        invoiceNrInputRef.current.select?.();
      }
    }, 0);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!validateBeforeSubmit()) {
      if (!isEditMode) {
        focusInvoiceField();
      }
      return;
    }

    setIsSubmitting(true);
    const payload = {
      Date: date,
      PayDate: payDate,
      ActionType: "EXB",
      InvoiceNr: invoiceNr,
      AccountID: accountId,
      SupplierID: supplierId,
      Amount0: amount0,
      Amount8: amount8,
      Amount18: amount18,
      PaymentOptions: Number(paymentOptions || 0),
      TransactionType: Number(transactionType),
      CompanyUnitID: unitId && Number(unitId) > 0 ? Number(unitId) : null,
      Coment: comment,
      CreatedByUser: createdByUser,
    };

    try {
      if (isEditMode) {
        const editPayload = {
          ...payload,
          TransactionID: Number(editingTransactionId || transactionId),
          AccountID: supplierId,
          AccountIDSpare: accountId,
          ModifiedByUser: createdByUser,
        };

        await axios.put(
          ApiLink.API_URL + "ExpensePurchases/update-expense-purchase",
          editPayload,
          {
            headers,
          },
        );
        handleSuccess("Shpenzimi u përditësua me sukses");
        closePage();
      } else {
        await axios.post(
          ApiLink.API_URL + "ExpensePurchases/insert-expense-purchase",
          payload,
          {
            headers,
          },
        );
        handleSuccess("Shpenzimi u ruajt me sukses");
        resetForm();
        focusInvoiceField();
      }
    } catch (error) {
      if (error?.response?.status === 409) {
        errorAlert(error.response.data);
      } else {
        errorAlert(
          getApiErrorMessage(
            error,
            isEditMode
              ? "Ndodhi gabim gjatë përditësimit të shpenzimit."
              : "Ndodhi gabim gjatë ruajtjes së shpenzimit.",
          ),
        );
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isInitializing) {
    return (
      <div className="purchase-form-page" style={{ minHeight: "280px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            minHeight: "280px",
          }}
        >
          <CircularProgress size={28} />
        </div>
      </div>
    );
  }

  return (
    <div className="purchase-form-page">
      <div className="purchase-form-header">
        <div>
          <h2 className="purchase-form-title">
            {isEditMode ? "Ndrysho shpenzimin" : "Shpenzim i ri në total"}
          </h2>
          <p className="purchase-form-subtitle">
            {isEditMode
              ? "Përditëso fushat e shpenzimit dhe ruaj ndryshimet."
              : "Plotëso fushat kryesore dhe ruaj faturën e shpenzimit."}
          </p>
        </div>

        <div className="purchase-form-header-actions">
          {!isEditMode && (
            <button
              type="button"
              className="purchase-btn purchase-btn-secondary"
              onClick={resetForm}
              disabled={isSubmitting}
            >
              Pastro
            </button>
          )}
          <button
            type="button"
            className="purchase-btn purchase-btn-ghost"
            onClick={handleCloseClick}
            disabled={isSubmitting}
          >
            Mbyll
          </button>
          <button
            type="submit"
            form="purchase-form"
            className={`purchase-btn purchase-btn-primary${invNumberExist > 0 ? " invoice-exists" : ""}`}
            disabled={
              isSubmitting ||
              invNumberExist > 0 ||
              (!isEditMode && isInsertFormEmpty) ||
              (isEditMode && !isFormDirty)
            }
          >
            {isSubmitting ? (
              <CircularProgress size={18} style={{ color: "#fff" }} />
            ) : invNumberExist > 0 ? (
              "Ky numër i faturës ekziston"
            ) : isEditMode ? (
              "Përditëso"
            ) : (
              "Ruaj"
            )}
          </button>
        </div>
      </div>

      <form
        id="purchase-form"
        className="purchase-form-body"
        onSubmit={handleSubmit}
        noValidate
      >
        <div className="purchase-top-grid">
          <section className="purchase-card purchase-card-elevated">
            <div className="purchase-card-headline">
              <h3 className="purchase-card-title">
                Informacioni i Përgjithshëm
              </h3>
              <span className="purchase-card-chip">Dokumenti</span>
            </div>

            <div className="purchase-form-cluster">
              <p className="purchase-cluster-title">Detajet e Dokumentit</p>
              <div className="purchase-grid two-columns">
                <div className="purchase-grid-full">
                  <TextField
                    label="Numri i Faturës"
                    value={invoiceNr}
                    inputRef={invoiceNrInputRef}
                    onChange={(event) => {
                      setInvoiceNr(event.target.value);
                      if (validationErrors.invoiceNr) {
                        setValidationErrors((prev) => ({
                          ...prev,
                          invoiceNr: "",
                        }));
                      }
                    }}
                    error={
                      invNumberExist > 0 || Boolean(validationErrors.invoiceNr)
                    }
                    helperText={
                      invNumberExist > 0
                        ? "Ky numër i faturës ekziston."
                        : validationErrors.invoiceNr || undefined
                    }
                    fullWidth
                  />
                </div>

                <TextField
                  label="Data e Faturës"
                  type="date"
                  value={date}
                  onChange={(event) => {
                    const nextDate = event.target.value;
                    setDate(nextDate);
                    if (validationErrors.date) {
                      setValidationErrors((prev) => ({ ...prev, date: "" }));
                    }
                    if (validationErrors.payDate) {
                      setValidationErrors((prev) => ({ ...prev, payDate: "" }));
                    }
                  }}
                  inputProps={{ min: minDate, max: maxDate }}
                  InputLabelProps={{ shrink: true }}
                  error={Boolean(validationErrors.date)}
                  helperText={validationErrors.date || ""}
                />

                <TextField
                  label="Data e Pagesës"
                  type="date"
                  value={payDate}
                  onChange={(event) => {
                    const nextPayDate = event.target.value;
                    setPayDate(nextPayDate);
                    setPayDateManuallyEdited(
                      Boolean(nextPayDate && nextPayDate !== date),
                    );
                    if (validationErrors.payDate) {
                      setValidationErrors((prev) => ({ ...prev, payDate: "" }));
                    }
                  }}
                  inputProps={{ min: minDate, max: maxDate }}
                  InputLabelProps={{ shrink: true }}
                  error={Boolean(validationErrors.payDate)}
                  helperText={validationErrors.payDate || ""}
                />

                <div className="purchase-grid-full">
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 0 }}
                  >
                    <div style={{ flex: 1 }}>
                      {isEditMode ? (
                        <AccountsAutocompleteEdit
                          ledgerID={302}
                          textFieldWidth="100%"
                          accountID={supplierId}
                          labelId="supplier-account"
                          label="Furnitori"
                          onSelect={(account) => {
                            setSupplierId(account.AccountID);
                            setSupplierOption(account);
                            if (validationErrors.supplierId) {
                              setValidationErrors((prev) => ({
                                ...prev,
                                supplierId: "",
                              }));
                            }
                          }}
                          onClear={() => {
                            setSupplierId("");
                            setSupplierOption(null);
                          }}
                        />
                      ) : (
                        <AccountsAutocompleteInsert
                          ledgerID={302}
                          textFieldWidth="100%"
                          value={supplierOption}
                          label="Furnitori"
                          labelId="supplier-account"
                          disableAutoFocus
                          onSelect={(account) => {
                            setSupplierId(account.AccountID);
                            setSupplierOption(account);
                            if (validationErrors.supplierId) {
                              setValidationErrors((prev) => ({
                                ...prev,
                                supplierId: "",
                              }));
                            }
                          }}
                          onClear={() => {
                            setSupplierId("");
                            setSupplierOption(null);
                          }}
                          InputProps={{
                            sx: {
                              borderRadius: 0,
                              height: 56,
                              minHeight: 56,
                              maxHeight: 56,
                              "& .MuiInputBase-input": {
                                height: 56,
                                minHeight: 56,
                                maxHeight: 56,
                                boxSizing: "border-box",
                                padding: "0 14px",
                                display: "flex",
                                alignItems: "center",
                              },
                            },
                          }}
                        />
                      )}
                    </div>
                    <IconButton
                      size="small"
                      onClick={() => setShowSupplierModal(true)}
                      aria-label="Shto furnitor"
                      title="Shto furnitor"
                      sx={{
                        border: "1px solid #c5d8ce",
                        borderRadius: "8px",
                        color: "#2f5649",
                        fontSize: "22px",
                        fontWeight: 700,
                        width: 48,
                        height: 48,
                        minWidth: 48,
                        minHeight: 48,
                        maxWidth: 48,
                        maxHeight: 48,
                        p: 0,
                        lineHeight: 1,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      +
                    </IconButton>
                  </div>
                  {validationErrors.supplierId && (
                    <div
                      style={{
                        marginTop: 6,
                        color: "#d32f2f",
                        fontSize: 12,
                        lineHeight: 1.3,
                      }}
                    >
                      {validationErrors.supplierId}
                    </div>
                  )}
                </div>
                {invoiceOtherSupplierMessage && invNumberExist <= 0 && (
                  <div className="purchase-grid-full">
                    <div
                      style={{
                        marginTop: 4,
                        padding: "10px 12px",
                        borderRadius: 8,
                        border: "1px solid #f2c078",
                        background: "#fff8ee",
                        color: "#8b5e1a",
                        fontSize: 12,
                        lineHeight: 1.35,
                      }}
                    >
                      {invoiceOtherSupplierMessage}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </section>

          <section className="purchase-card purchase-card-elevated">
            <div className="purchase-card-headline">
              <h3 className="purchase-card-title">Klasifikimi</h3>
              <span className="purchase-card-chip">Kontabiliteti</span>
            </div>

            <div className="purchase-form-cluster">
              <p className="purchase-cluster-title">
                Kategorizimi i Shpenzimit
              </p>
              <div className="purchase-grid two-columns">
                <div className="purchase-grid-full">
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 0 }}
                  >
                    <div style={{ flex: 1 }}>
                      <Autocomplete
                        options={expenseAccounts}
                        value={expenseOption}
                        onChange={(_, value) => {
                          if (!value) {
                            setAccountId("");
                            setExpenseOption(null);
                            return;
                          }
                          setAccountId(value.AccountID);
                          setExpenseOption(value);
                          if (validationErrors.accountId) {
                            setValidationErrors((prev) => ({
                              ...prev,
                              accountId: "",
                            }));
                          }
                        }}
                        getOptionLabel={(option) => option.AccountName || ""}
                        popupIcon={sharedDropdownIcon({})}
                        ListboxProps={{
                          style: {
                            fontSize: "13px",
                          },
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Llogaria Kontabël"
                            fullWidth
                            InputProps={{
                              ...params.InputProps,
                              sx: {
                                borderRadius: 8,
                                height: 48,
                                minHeight: 48,
                                maxHeight: 48,
                                background: "#f5f9f7",
                                borderColor: "#d4e2db",
                                "&.MuiAutocomplete-inputRoot": {
                                  alignItems: "center",
                                  paddingTop: 0,
                                  paddingBottom: 0,
                                },
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    borderColor: "#4E7B67",
                                  },
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "#4E7B67",
                                },
                                "& .MuiInputBase-input": {
                                  height: "auto",
                                  minHeight: "unset",
                                  maxHeight: "unset",
                                  boxSizing: "border-box",
                                  display: "flex",
                                  alignItems: "center",
                                  padding: "0 14px",
                                },
                                "& .MuiAutocomplete-input": {
                                  paddingTop: "0 !important",
                                  paddingBottom: "0 !important",
                                },
                              },
                            }}
                            FormControlProps={{
                              sx: {
                                borderRadius: 8,
                                height: 48,
                                minHeight: 48,
                                maxHeight: 48,
                              },
                            }}
                            InputLabelProps={{ shrink: true }}
                          />
                        )}
                      />
                    </div>
                    <IconButton
                      size="small"
                      onClick={() => setShowExpenseModal(true)}
                      aria-label="Shto klasë shpenzimi"
                      title="Shto klasë shpenzimi"
                      sx={{
                        border: "1px solid #c5d8ce",
                        borderRadius: "8px",
                        color: "#2f5649",
                        fontSize: "22px",
                        fontWeight: 700,
                        width: 48,
                        height: 48,
                        minWidth: 48,
                        minHeight: 48,
                        maxWidth: 48,
                        maxHeight: 48,
                        p: 0,
                        lineHeight: 1,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      +
                    </IconButton>
                  </div>
                  {validationErrors.accountId && (
                    <div
                      style={{
                        marginTop: 6,
                        color: "#d32f2f",
                        fontSize: 12,
                        lineHeight: 1.3,
                      }}
                    >
                      {validationErrors.accountId}
                    </div>
                  )}
                </div>

                <TextField
                  select
                  label="Lloji i Blerjes"
                  value={transactionType}
                  onChange={(event) => setTransactionType(event.target.value)}
                  SelectProps={{
                    MenuProps: paymentMenuProps,
                    IconComponent: sharedDropdownIcon,
                  }}
                  InputProps={{
                    sx: {
                      borderRadius: 8,
                      height: 48,
                      minHeight: 48,
                      maxHeight: 48,
                      background: "#f5f9f7",
                      borderColor: "#d4e2db",
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#4E7B67",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#4E7B67",
                      },
                      "& .MuiSelect-select, & .MuiInputBase-input": {
                        height: 48,
                        minHeight: 48,
                        maxHeight: 48,
                        boxSizing: "border-box",
                        display: "flex",
                        alignItems: "center",
                        padding: "0 14px",
                      },
                    },
                  }}
                  FormControlProps={{
                    sx: {
                      borderRadius: 8,
                      height: 48,
                      minHeight: 48,
                      maxHeight: 48,
                    },
                  }}
                  InputLabelProps={{ shrink: true }}
                >
                  {TRANSACTION_TYPES.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.type}
                    </MenuItem>
                  ))}
                </TextField>

                {isEditMode ? (
                  <TextField
                    select
                    label="Mënyra Pagesës"
                    value={paymentOptions}
                    onChange={(event) => {
                      setPaymentOptions(event.target.value);
                      if (validationErrors.paymentOptions) {
                        setValidationErrors((prev) => ({
                          ...prev,
                          paymentOptions: "",
                        }));
                      }
                    }}
                    error={Boolean(validationErrors.paymentOptions)}
                    helperText={validationErrors.paymentOptions || ""}
                    SelectProps={{
                      MenuProps: paymentMenuProps,
                      IconComponent: sharedDropdownIcon,
                    }}
                    InputProps={{
                      sx: {
                        borderRadius: 8,
                        height: 48,
                        minHeight: 48,
                        maxHeight: 48,
                        background: "#f5f9f7",
                        borderColor: "#d4e2db",
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#4E7B67",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#4E7B67",
                        },
                        "& .MuiSelect-select, & .MuiInputBase-input": {
                          height: 48,
                          minHeight: 48,
                          maxHeight: 48,
                          boxSizing: "border-box",
                          display: "flex",
                          alignItems: "center",
                          padding: "0 14px",
                        },
                      },
                    }}
                    FormControlProps={{
                      sx: {
                        borderRadius: 8,
                        height: 48,
                        minHeight: 48,
                        maxHeight: 48,
                      },
                    }}
                    InputLabelProps={{ shrink: true }}
                  >
                    <MenuItem key="0" value="0">
                      Pagesa Behet më vonë
                    </MenuItem>
                    {paymentTypes.map((data) => (
                      <MenuItem
                        key={data.AccountID}
                        value={String(data.AccountID)}
                      >
                        {data.AccountName}
                      </MenuItem>
                    ))}
                  </TextField>
                ) : (
                  <PaymentTypeSelect
                    value={paymentOptions}
                    onChange={(event) => {
                      setPaymentOptions(event.target.value);
                      if (validationErrors.paymentOptions) {
                        setValidationErrors((prev) => ({
                          ...prev,
                          paymentOptions: "",
                        }));
                      }
                    }}
                    error={Boolean(validationErrors.paymentOptions)}
                    helperText={validationErrors.paymentOptions || ""}
                    sx={{ borderRadius: 8 }}
                  />
                )}

                <div className="purchase-grid-full">
                  <TextField
                    className="purchase-comment"
                    label="Komenti"
                    multiline
                    rows={1}
                    value={comment}
                    onChange={(event) => setComment(event.target.value)}
                  />
                </div>
              </div>
            </div>
          </section>
        </div>

        <section className="purchase-card">
          <h3 className="purchase-card-title">Vlerat dhe TVSH</h3>

          <div className="purchase-vat-table">
            <div className="purchase-vat-head">
              <div>Norma TVSH</div>
              <div>Vlera pa TVSH</div>
              <div>Vlera e TVSH</div>
              <div>Total</div>
            </div>

            {isVatDeclarant && (
              <>
                <div className="purchase-vat-row">
                  <div className="purchase-vat-rate">18%</div>
                  <PriceField
                    label=""
                    name="amount18"
                    value={amount18}
                    onChange={(event) => recalcByNet(event.target.value, 18)}
                  />
                  <PriceField
                    label=""
                    name="vat18"
                    value={vat18}
                    onChange={(event) => recalcFromVat(event.target.value, 18)}
                  />
                  <PriceField
                    label=""
                    name="total18"
                    value={total18}
                    decimalScale={2}
                    onChange={(event) => recalcByTotal(event.target.value, 18)}
                  />
                </div>

                <div className="purchase-vat-row">
                  <div className="purchase-vat-rate">8%</div>
                  <PriceField
                    label=""
                    name="amount8"
                    value={amount8}
                    onChange={(event) => recalcByNet(event.target.value, 8)}
                  />
                  <PriceField
                    label=""
                    name="vat8"
                    value={vat8}
                    onChange={(event) => recalcFromVat(event.target.value, 8)}
                  />
                  <PriceField
                    label=""
                    name="total8"
                    value={total8}
                    decimalScale={2}
                    onChange={(event) => recalcByTotal(event.target.value, 8)}
                  />
                </div>
              </>
            )}

            <div className="purchase-vat-row">
              <div className="purchase-vat-rate">0%</div>
              <PriceField
                label=""
                name="amount0"
                value={amount0}
                onChange={(event) => recalcByNet(event.target.value, 0)}
              />
              <PriceField label="" name="vat0" value={0} disabled />
              <PriceField
                label=""
                name="total0"
                value={total0}
                decimalScale={2}
                onChange={(event) => recalcByTotal(event.target.value, 0)}
              />
            </div>
          </div>

          <div className="purchase-vat-totals-row">
            <div className="purchase-vat-totals-label">Totale</div>
            <div className="purchase-vat-total-item">
              <span>Total pa TVSH</span>
              <strong>{formatEuroValue(totals.totalNoVat)} €</strong>
            </div>
            <div className="purchase-vat-total-item">
              <span>Total TVSH</span>
              <strong>{formatEuroValue(totals.totalVat)} €</strong>
            </div>
            <div className="purchase-vat-total-item grand-total">
              <span>Total me TVSH</span>
              <strong>{formatEuroValue(totals.totalWithVat)} €</strong>
            </div>
          </div>
        </section>
      </form>

      <SuppliersModal
        show={showSupplierModal}
        onHide={() => setShowSupplierModal(false)}
        mode="insert"
        type="none"
      />

      <ExpencesTypeModal
        show={showExpenseModal}
        onHide={() => setShowExpenseModal(false)}
        mode="insert"
        type="none"
        fetchData={fetchExpenseAccounts}
      />

      <Dialog
        open={showCloseConfirm}
        onClose={() => setShowCloseConfirm(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Konfirmo mbylljen</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Ke ndryshime të paruajtura. Nëse mbyll këtë formë, të dhënat e
            pa-ruajtura do të humbin. A je i sigurt që dëshiron të vazhdosh?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setShowCloseConfirm(false)} color="inherit">
            Anulo
          </Button>
          <Button
            onClick={() => {
              setShowCloseConfirm(false);
              closePage();
            }}
            variant="contained"
            sx={{
              backgroundColor: "#2f5649",
              "&:hover": { backgroundColor: "#284945" },
            }}
          >
            Po, mbylle
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
